import { render, staticRenderFns } from "./AppAlerts.vue?vue&type=template&id=783aa99f&scoped=true"
import script from "./AppAlerts.vue?vue&type=script&lang=js"
export * from "./AppAlerts.vue?vue&type=script&lang=js"
import style0 from "./AppAlerts.vue?vue&type=style&index=0&id=783aa99f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783aa99f",
  null
  
)

export default component.exports